var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{
    [_vm.styles.air__menuLeft__item]: true,
    [_vm.styles.air__menuLeft__item__active]: _vm.item.key === _vm.activeItem,
    [`${_vm.theme}-menu-active`]: _vm.item.key === _vm.activeItem,
  }},[(!_vm.item.isExternal)?_c('router-link',{class:_vm.styles.air__menuLeft__link,attrs:{"to":_vm.redirectUrl}},[(_vm.item.icon)?_c('i',{class:{
        [_vm.item.icon]: true,
        [_vm.styles.air__menuLeft__icon]: true,
      }}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.item.title))]),(_vm.item.badge_number)?_c('span',{staticStyle:{"background-color":"red","width":"20px","height":"18px","color":"white","font-size":"14px","border-radius":"10px","display":"inline-block","text-align":"center","line-height":"1.2rem","margin-left":"5px"}},[_vm._v(_vm._s(_vm.item.badge_number))]):_vm._e(),(_vm.item.badge)?_c('span',{attrs:{"title":_vm.item.badge.hover}},[_c('i',{class:{
          [_vm.item.badge.icon]: true,
          'menu-badge': true,
        }})]):_vm._e()]):_c('a',{class:_vm.styles.air__menuLeft__link,attrs:{"href":_vm.item.url,"target":"_blank","rel":"noopener noreferrer"}},[(_vm.item.icon)?_c('i',{class:{
        [_vm.item.icon]: true,
        [_vm.styles.air__menuLeft__icon]: true,
      }}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.item.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }